import { useSubject } from '@aesop-fables/scrinium';
import { CategoryData } from '../models/CourseData';
import { LessonCategoriesSubject } from '../data/learning/subjects/LessonCategoriesSubject';

export function useLessonCategories() {
  const categories = useSubject<CategoryData[]>(LessonCategoriesSubject);
  return categories;
}
